<template>
    <p v-if="exactError" class="error invalid-feedback mb-0" :id="`error_${name}`">
        <span v-for="error in exactError">{{ error }}<br/></span>
    </p>
</template>

<script>
export default {
    name: "ErrorText",

    props: {
        errors: Object | Array,
        name: String,
    },

    computed: {
        exactError() {
            if (this.errors[this.name]) {
                return this.errors[this.name];
            }
            return Object
                .keys(this.errors)
                .filter(name => {
                    if (name.startsWith(`${this.name}.`)) {
                        return true;
                    }
                })
                .map(name => this.errors[name])
                .flat();
        }
    }
}
</script>

<style scoped>

</style>
